import Decimal from 'decimal.js-light';
import compact from 'lodash/compact';
import PropTypes from 'prop-types';

const FormattedNumber = ({ number, decimalPlaces }) => {
  const decimal = new Decimal(number);
  const numberAsString = decimalPlaces !== undefined ? decimal.toFixed(decimalPlaces) : decimal.toString();
  const parts = numberAsString.split('.');
  return compact([parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), parts[1]]).join('.');
};

FormattedNumber.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Decimal)]).isRequired,
  decimalPlaces: PropTypes.number,
};

FormattedNumber.defaultProps = {
  decimalPlaces: undefined,
};

export default FormattedNumber;
